import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';

export const homeColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_accountCode,
    getColumns_invoiceID,
    getColumns_SqlAccountInvoiceNo,
    getColumns_date,
    getColumns_amount,
    getColumns_lastSentEmail,
    getColumns_documentDate,
    getColumns_status,
}

function getColumns() {
    return [
        getColumns_invoiceID(),
        getColumns_SqlAccountInvoiceNo(),
        getColumns_accountCode(),
        getColumns_date(),
        getColumns_documentDate(),
        getColumns_lastSentEmail(),
        getColumns_amount(),
        // getColumns_status(),
    ];
}

function getColumns_accountCode() {
    let columnClassName = "home-tableColumn-accountCode";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Account Code",
        id: "accountCode",
        accessor: "AccountCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_invoiceID() {
    let columnClassName = "home-tableColumn-invoiceID";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Invoice ID",
        id: "invoiceID",
        accessor: "Id",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_SqlAccountInvoiceNo() {
    let columnClassName = "home-tableColumn-sqlAccountInvoiceNo";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Document No.",
        id: "sqlAccountInvoiceNo",
        accessor: "ReferenceDocumentNo",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_date() {
    let columnClassName = "home-tableColumn-issueDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Issue Date",
        // isHeaderColumnSortable: true,
        // sortValue: "issueDate"
        id: "issueDate",
        accessor: "IssueDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_amount() {
    let columnClassName = "home-tableColumn-subtotal";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "SubTotal (RM)",
        // isHeaderColumnSortable: true,
        // sortValue: "subTotal"
        id: "subTotal",
        accessor: "SubTotal",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";
            if (value_formatted != "-")
                value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_lastSentEmail() {
    let columnClassName = "home-tableColumn-lastSentEmail";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Last Sent Email",
        // isHeaderColumnSortable: true,
        // sortValue: "lastSentEmail"
        id: "lastSentEmail",
        accessor: "LastSendEmail",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_documentDate() {
    let columnClassName = "home-tableColumn-documentDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Document Date",
        // isHeaderColumnSortable: true,
        // sortValue: "documentDate"
        id: "documentDate",
        accessor: "DocumentDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_status() {
    let columnClassName = "home-tableColumn-status";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Status",
        // isHeaderColumnSortable: true,
        // sortValue: "status"
        id: "status",
        accessor: "LastSendEmail",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? "Sent": "-";

            // Status Color
            let statusIconColor = "home-columnStatus-icon_pending";
            switch (value_formatted) {
                case "Sent":
                    statusIconColor = "home-columnStatus-icon_success";
                    break;
                case "Incomplete":
                    statusIconColor = "home-columnStatus-icon_failure";
                    break;
                default:
                    break;
            }

            return (
                <div className={"noWrap-text-ellipsis"}>
                    {func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")? 
                        (<FontAwesomeIcon 
                            className={"home-columnStatus-icon " + statusIconColor} 
                            icon={faCircle}
                        />
                    ):""}
                    <span>{value_formatted}</span>
                </div>
            );
        },
    }
}